import script from "./VehicleMap.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehicleMap.vue?vue&type=script&setup=true&lang=ts"

import "./VehicleMap.vue?vue&type=style&index=0&id=4f2cf967&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f2cf967"]])

export default __exports__